module.exports = __webpack_public_path__ + "static/media/hero-4.eeabec48.jpg";